




























































































































































































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import PreviewImageSidebar from "../../components/PreviewImageSidebar.vue";
import { BModal, BCarousel, BSidebar } from 'bootstrap-vue';
import ReviewArea from "../../components/ReviewArea.vue";
import CustomConfirm from "../../components/CustomConfirmModal.vue";
import { Sheet, SheetField, Examinee, SheetActivity, FieldActivity, ScoreOption, ReviewText, SaitenStickyNote } from "../../modules/teacher/SaitenList";

export interface Data {
  sheet_id: string
  sheet: Sheet | null
  sheetFields: SheetField[] | null
  sheetField: SheetField
  examinees: Examinee[]
  isDispStudentInfo: boolean
  isExistsStudentNoCharacter: boolean
  isExistsStudentName: boolean
  studentNoCharacterWidth: number
  studentNameWidth: number
  rightTableTdWidth: string
  colspan: number
  totalScoreAverage: number
  totalScoreRate: number
  totalFieldCount: number
  totalFirstSaitenCompletedCount: number
  totalSecondSaitenCompletedCount: number
  totalThirdSaitenCompletedCount: number
  delayedJobCount: number
  isSaitenCompleted: boolean
  isStudentNoSortDesc: boolean
  isTotalScoreSortDesc: boolean
  isFieldScoreSortDest: boolean
  isPdfJobProcessing: boolean
  modalExaminee: Examinee | null
  modalImageKind: number
  carouselPageIdx: number
  windowHeight: number
  scoreOptions: ScoreOption[]
  errors: string[]
  isReviewImageVisible: boolean
  isReviewOverlay: boolean
  reviewOverlayText: string
  isScanImageVisible: boolean
  scanImageExamineeIds: number[]
  previewScanImageExamineeId: number
  pcHelpFields: any[]
  tabletHelpFields: any[]
  isResultImageVisible: boolean
  resultImageExamineeIds: number[]
  previewResultImageExamineeId: number
  isPdfDownloadSingleFile: boolean
  approval_flg: boolean
  isFilterMisaiten: boolean
  dispSheetFieldIds: number[]
  allSaitenStickyNotes: SaitenStickyNote[]
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "review-area": ReviewArea,
    "preview-image-sidebar": PreviewImageSidebar,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const pdfDownlaodModalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    const reviewAreaRef = ref<InstanceType<typeof ReviewArea>>();
    const sidebarReviewlImageRef = ref<InstanceType<typeof BSidebar>>();
    const previewScanImageSidebarRef = ref<InstanceType<typeof PreviewImageSidebar>>();
    const previewResultImageSidebarRef = ref<InstanceType<typeof PreviewImageSidebar>>();
    const customConfirmModalRef = ref<InstanceType<typeof CustomConfirm>>();
    const confirmChangeAllotRef = ref<InstanceType<typeof CustomConfirm>>();

    const AnswerImageTypeEnum = Common.AnswerImageTypeEnum;
    const CompareNoEnum = Common.CompareNoEnum;

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: null,
      sheetFields: [],
      sheetField: null,
      examinees: [],
      isDispStudentInfo: false,
      isExistsStudentNoCharacter: false,
      isExistsStudentName: false,
      studentNoCharacterWidth: 0,
      studentNameWidth: 0,
      rightTableTdWidth: "",
      colspan: 3,
      totalScoreAverage: 0,
      totalScoreRate: 0,
      totalFieldCount: 0,
      totalFirstSaitenCompletedCount: 0,
      totalSecondSaitenCompletedCount: 0,
      totalThirdSaitenCompletedCount: 0,
      delayedJobCount: 0,
      isSaitenCompleted: false,
      isStudentNoSortDesc: false,
      isTotalScoreSortDesc: false,
      isFieldScoreSortDest: false,
      isPdfJobProcessing: false,
      modalExaminee: null,
      modalImageKind: AnswerImageTypeEnum.Scan,
      carouselPageIdx: 0,
      windowHeight: 0,
      scoreOptions: new Array<ScoreOption>(),
      errors: [],
      isReviewImageVisible: false,
      isReviewOverlay: false,
      reviewOverlayText: "",
      isScanImageVisible: false,
      scanImageExamineeIds: [],
      previewScanImageExamineeId: null,
      pcHelpFields: [
        { key: "Tキー + クリック", img: require("@/assets/images/keyboard_T.png"), description: "テキストを出力" },
        { key: "テキスト選択中にBackSpaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "テキストを削除" },
        { key: "答案上を長押し", description: "長押しした場所にテキストを出力" },
        { key: "テキストを長押し", description: "長押ししたテキストを削除" },
        { key: "Dキー + マウス", img: require("@/assets/images/keyboard_D.png"), description: "自由線" },
        { key: "Eキー + マウス", img: require("@/assets/images/keyboard_E.png"), description: "消しゴム" },
        { key: "Ctrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
      ],
      tabletHelpFields: [
        { key: "答案上を長押し", description: "長押しした場所にテキストを出力" },
        { key: "テキストを長押し", description: "長押ししたテキストを削除" },
      ],
      isResultImageVisible: false,
      resultImageExamineeIds: [],
      previewResultImageExamineeId: null,
      isPdfDownloadSingleFile: false,
      approval_flg: false,
      isFilterMisaiten: false,
      dispSheetFieldIds: [],
      allSaitenStickyNotes: [],
    });

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      state.windowHeight = windowHeight;

      if(tableArea != null){
        tableArea.style.height = (windowHeight - tableArea.offsetTop) + "px";
      }
    };

    /************************************************************
     * テーブルスクロールイベント
     ************************************************************/

    const scrollChanged = () => {
      const topRightTableArea: Element = document.getElementById("top-right-table-area");
      const bottomLeftTableArea: Element = document.getElementById("bottom-left-table-area");
      const bottomRightTableArea: Element = document.getElementById("bottom-right-table-area");

      topRightTableArea.scrollLeft = bottomRightTableArea.scrollLeft;
      bottomLeftTableArea.scrollTop = bottomRightTableArea.scrollTop;
    };

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    /************************************************************
     * 採点画像・エクセル出力可否判定
     ************************************************************/

    const isExcelPdfButtonEnable = computed((): boolean => {
      if(context.root.$store.getters.isEntranceOrPractice){
        return state.isSaitenCompleted && state.sheet.approval_flg;
      }else{
        return state.isSaitenCompleted;
      }
    });

    /************************************************************
     * 採点画像ボタン表示判定
     ************************************************************/

    const isPdfButtonVisible = computed((): boolean => {
      // admin権限、又は入試・模試の管理者は表示（コンペアのA採点・B採点は非表示）
      if(context.root.$store.getters.isCompareFirstOrSecond){
        return false;
      }else if(context.root.$store.state.currentUser.role == Common.RoleEnum.Admin){
        return true;
      }else if(context.root.$store.getters.isEntranceOrPractice && context.root.$store.getters.isAdminOrTeacher1){
        return true;
      }else{
        return false;
      }
    });

    /************************************************************
     * 画像作成ボタン押下
     ************************************************************/

    const createPdfJob = async () => {
      if(!window.confirm("採点画像作成を実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/teacher/saiten_list/create_pdf_job/${state.sheet_id}`).then(response => {
        alert("採点画像作成を開始しました");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * Excel出力ボタン押下
     ************************************************************/

    const downloadExcel = async () => {
      if(!window.confirm("採点結果Excelファイルを出力します。よろしいですか？")){
        return;
      }

      await http.get(`/api/teacher/saiten_list/download_excel/${state.sheet_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `採点結果_${state.sheet.name}_${state.sheet.room_name}組.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 承認ボタン押下
     * A・B採点の承認リセットに連動して最終採点の承認もリセットされる場合は
     * モーダルに注意メッセージを表示
     * 最終採点・コンペア以外の採点の場合はそのまま更新
     ************************************************************/
    const approvalButtonClick = async (approval_flg: boolean) => {
      
      state.approval_flg = approval_flg;
      const msg = state.approval_flg ? "この試験を承認します。よろしいですか？" : "承認を解除します。よろしいですか？";
      
      let param: any = {approval_flg: state.approval_flg};
      if(context.root.$store.getters.isCompareFirstOrSecond){
        param["compare_no"] = context.root.$store.state.compare_no;
      }

      if(context.root.$store.getters.isCompareFirstOrSecond && !state.approval_flg){
        await http.post(`/api/teacher/saiten_list/is_compare_final_scored/${state.sheet_id}`, param).then(response => {
          if(response.data.result){
            customConfirmModalRef.value.show();
          }else{
            if(window.confirm(msg)){
              updateApproval();
            }
          }
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      }else{
        if(window.confirm(msg)){
          updateApproval();
        }
      }
    }

    /************************************************************
     * 承認状態更新
     ************************************************************/

    const updateApproval = async () => {

      customConfirmModalRef.value.hide();
      
      let param: any = {approval_flg: state.approval_flg};
      if(context.root.$store.getters.isCompareFirstOrSecond){
        param["compare_no"] = context.root.$store.state.compare_no;
      }

      await http.post(`/api/teacher/saiten_list/update_approval/${state.sheet_id}`, param).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 出席番号列でソート
     ************************************************************/

    const sortStudentNo = () => {
      state.isStudentNoSortDesc = !state.isStudentNoSortDesc;
      if(state.isStudentNoSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.student_no - b.student_no).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.student_no - b.student_no);
      }
    }

    /************************************************************
     * 合計得点列でソート
     ************************************************************/

    const sortTotalScore = () => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.score - b.score).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.score - b.score);
      }
    };

    /************************************************************
     * 設問列でソート
     ************************************************************/

    const sortFieldScore = (idx: number) => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.examinees = state.examinees.sort((a, b) => sortFieldScoreSub(idx, a, b)).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => sortFieldScoreSub(idx, a, b));
      }
    };

    /************************************************************
     * 設問列のソートロジック 得点でソートする
     * 誤答・未採点・欠席者を区別するため
     * ダミー得点として未採点は-1、欠席者は-2でソートする
     ************************************************************/

    const sortFieldScoreSub = (idx: number, e1: Examinee, e2: Examinee) => {
      let scoreA = 0, scoreB = 0;
      if(e1.fieldActivities.length > idx){
        scoreA = e1.fieldActivities[idx].score == null ? -1 : e1.fieldActivities[idx].score;
      }else{
        scoreA = -2;
      }
      if(e2.fieldActivities.length > idx){
        scoreB = e2.fieldActivities[idx].score == null ? -1 : e2.fieldActivities[idx].score;
      }else{
        scoreB = -2;
      }
      return scoreA - scoreB;
    }

    /************************************************************
     * モーダル種別に応じた答案or採点結果画像base64を返却
     ************************************************************/

    const base64Images = computed((): string[] => {
      if(state.modalExaminee == null){
        return [];
      }else if(state.modalImageKind == AnswerImageTypeEnum.Scan){
        return state.modalExaminee.base64ScanImages;
      }else{
        return state.modalExaminee.base64ResultImages
      }
    });

    /************************************************************
     * モーダルのtitleを返却
     ************************************************************/

    const modalTitle = computed((): string => {
      if(state.modalExaminee == null){
        return "";
      }
      
      if(context.root.$store.getters.isEntranceOrPractice){
        if(state.modalImageKind == AnswerImageTypeEnum.Scan){
          return `答案画像　受験番号：${state.modalExaminee.student_no_character}`;
        }else{
          return `採点結果　受験番号：${state.modalExaminee.student_no_character}`;
        }
      }else{
        if(state.modalImageKind == AnswerImageTypeEnum.Scan){
          return `答案画像　出席番号：${state.modalExaminee.student_no}番`;
        }else{
          return `採点結果　出席番号：${state.modalExaminee.student_no}番`;
        }
      }
    });

    /************************************************************
     * 画像モーダル表示
     ************************************************************/

    const showModalImage = async (examinee: Examinee, imageKind: number) => {

      if((imageKind == AnswerImageTypeEnum.Scan && examinee.base64ScanImages.length == 0)
        || (imageKind == AnswerImageTypeEnum.ScoringResult && examinee.base64ResultImages.length == 0)){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage(examinee, imageKind)
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }
      state.modalExaminee = examinee;
      state.modalImageKind = imageKind;
      state.carouselPageIdx = 0;
      modalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async (examinee: Examinee, imageKind: number) => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const sheetActivityIds = examinee.sheetActivities.map(x => x.id);
      await http.get(`/api/teacher/saiten_list/download_image/${state.sheet_id}/${sheetActivityIds}/${imageKind}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          if(imageKind == AnswerImageTypeEnum.Scan){
            examinee.base64ScanImages.push(x);
          }else{
            examinee.base64ResultImages.push(x);
          }
        });
      })
      .catch(error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/

    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.sheet.page_count - 1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/

    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.sheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx - 1; i >= 0; i--){
        const examinee = state.examinees[i];
        if(!examinee.absent_flg){
          if((state.modalImageKind == AnswerImageTypeEnum.Scan && examinee.base64ScanImages.length == 0)
            || (state.modalImageKind == AnswerImageTypeEnum.ScoringResult && examinee.base64ResultImages.length == 0)){
            // 画像をダウンロード
            const isSuccess: boolean = await downloadImage(examinee, state.modalImageKind)
            if(!isSuccess){
              // ダウンロード失敗は処理終了
              return;
            }
          }
          state.modalExaminee = examinee;
          carouselRef.value.setSlide(state.carouselPageIdx);
          break;
        }
      }
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx + 1; state.examinees.length; i++){
        const examinee = state.examinees[i];
        if(!examinee.absent_flg){
          if((state.modalImageKind == AnswerImageTypeEnum.Scan && examinee.base64ScanImages.length == 0)
            || (state.modalImageKind == AnswerImageTypeEnum.ScoringResult && examinee.base64ResultImages.length == 0)){
            // 画像をダウンロード
            const isSuccess: boolean = await downloadImage(examinee, state.modalImageKind)
            if(!isSuccess){
              // ダウンロード失敗は処理終了
              return;
            }
          }
          state.modalExaminee = examinee;
          carouselRef.value.setSlide(state.carouselPageIdx);
          break;
        }
      }
    };

    /************************************************************
     * 講評画像 or 採点結果画像表示
     ************************************************************/

    const showReviewImage = async (examinee: Examinee) => {
      await initializeReviewExaminee(examinee);
      state.modalExaminee = examinee;
      state.isReviewImageVisible = true;
    };

    /************************************************************
     * 講評画像クローズ
     ************************************************************/

    const hiddenReviewImage = () => {
      state.isReviewImageVisible = false;
    }

    /************************************************************
     * 講評モーダルの表示対象画像初期化
     ************************************************************/

    const initializeReviewExaminee = async (examinee: Examinee) => {
      
      // 採点結果画像未DLの場合はDL実行
      if(examinee.base64ResultImages.length == 0){
        
        // 採点結果画像DL
        state.isReviewOverlay = true;
        state.reviewOverlayText = "画像データ取得中... しばらくお待ちください。";
        const sheetActivityIds = examinee.sheetActivities.map(x => x.id);
        await http.get(`/api/teacher/saiten_list/download_result_image/${state.sheet_id}/${sheetActivityIds}`).then(response => {
          response.data.base64_images.forEach((x: string) => {
            examinee.base64ResultImages.push(x);
          });

          examinee.sheetActivities.forEach((sheetActivity, i) => {
            const reviewTexts: ReviewText[] = response.data.review_texts.filter((x: ReviewText) => x.sheet_activity_id == sheetActivity.id);
            sheetActivity.reviewTexts = reviewTexts;
            sheetActivity.reviewImages = [];
            sheetActivity.idx = reviewTexts.length == 0 ? 0 : reviewTexts.map(x => x.idx).reduce((a,b)=>Math.max(a,b)) + 1;
            sheetActivity.base64Canvas = response.data.base64_canvases[i];
            sheetActivity.is_canvas_drawed = !!response.data.base64_canvases[i];
          });
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
        state.isReviewOverlay = false;
      }
    }

    /************************************************************
     * 講評モーダルの表示対象生徒切り替え
     * ReviewAreaからemitで呼ばれる
     ************************************************************/

    const changeReviewExaminee = async (examinee: Examinee, addCount: number) => {
      const attendExaminees = state.examinees.filter(x => !x.absent_flg);
      const idx = attendExaminees.indexOf(examinee) + addCount;
      
      if(idx < 0 || idx >= attendExaminees.length){
        return;
      }

      const newExaminee = attendExaminees[idx];
      await initializeReviewExaminee(newExaminee);
      state.modalExaminee = newExaminee;
    }

    /************************************************************
     * 講評コメント更新
     ************************************************************/

    const updateReview = async (param: object) => {

      state.isReviewOverlay = true;
      context.root.$store.dispatch("showOverlay");
      state.reviewOverlayText = "処理実行中... しばらくお待ちください。";

      await http.post(`/api/teacher/saiten_list/update_review_text`, param).then(response => {
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          reviewAreaRef.value.errors = error.response.data.errors;
        }else{
          reviewAreaRef.value.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      const examieeId = state.modalExaminee.id;
      const modalExaminee = state.examinees.filter(x => x.id == examieeId);
      if(modalExaminee){
        modalExaminee[0].base64ResultImages = [];
        await initializeReviewExaminee(modalExaminee[0]);
        state.modalExaminee = modalExaminee[0];
      }

      state.isReviewOverlay = false;
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * ダウンロードヘッダチェックボックス変更イベント
     ************************************************************/

    const allSelectChanged = (changedVal: boolean) => {
      state.examinees.filter(x => !x.absent_flg && x.result_image_created).forEach(x => {
        x.checked = changedVal;
      });
    };

    /************************************************************
     * ダウンロードアイコン押下
     ************************************************************/

    const downloadPdf = async () => {

      const studentIds = state.examinees.filter(x => !x.absent_flg && x.checked).map(x => x.student_no);
      if(studentIds.length == 0){
        alert("ダウンロード対象の生徒を選択してください。");
        return;
      }

      if(!window.confirm("PDFをダウンロードします。よろしいですか？")){
        return;
      }

      pdfDownlaodModalRef.value.hide();

      const param = {
        student_ids: studentIds
      }

      const apiName = state.isPdfDownloadSingleFile ? "download_pdf_single" : "download_pdf_multi";

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/saiten_list/${apiName}/${state.sheet_id}`, param, {responseType: 'arraybuffer'}).then(response => {
        if(state.isPdfDownloadSingleFile){
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `採点結果画像_${state.sheet.name}_${state.sheet.room_name}組.pdf`;
          a.click();
        }else{
          const blob = new Blob([response.data], { type: 'application/zip' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `採点結果画像_${state.sheet.name}.zip`;
          a.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 公開状態更新
     ************************************************************/

    const updatePublish = async () => {
      const examinees = state.examinees.filter(x => x.checked != null && x.checked != x.checkedCache);

      if(examinees.length == 0){
        alert("公開状態が変更されていません。");
        return;
      }

      if(!window.confirm("公開状態を更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/saiten_list/update_publish`, {sheet_id: state.sheet_id, examinees: examinees}).then(response => {
        state.examinees.forEach(x => x.checkedCache = x.checked);
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * ペンシルアイコン押下 採点画面へ遷移
     ************************************************************/

    const saitenStart = (sheetField: SheetField) => {
      const idx = state.sheetFields.indexOf(sheetField);
      const tdField = document.getElementById(`field-col-${idx}`);
      const fieldArea = document.getElementById(`top-right-table-area`);
      if(tdField && fieldArea){
        const displayLeft = tdField.offsetLeft - fieldArea.scrollLeft;
        context.root.$store.commit("setSaitenListDisplayLeft", displayLeft);
      }else{
        context.root.$store.commit("setSaitenListDisplayLeft", null);
      }

      context.root.$store.commit("setStartSheetId", state.sheet_id);
      
      if(sheetField.scoring_type == Common.ScoringTypeEnum.Seigo){
        context.root.$router.push(`/teacher_site/saiten_input/${state.sheet_id}/${sheetField.id}`).catch(err => {});
      }else if(Common.IsScoringTypeScoreStamp(sheetField.scoring_type)){
        context.root.$router.push(`/teacher_site/saiten_input_score_stamp/${state.sheet_id}/${sheetField.id}`).catch(err => {});
      }
    }

    /************************************************************
     * 一枚採点アイコン押下 一枚採点画面へ遷移
     ************************************************************/

    const saitenStartIchimai = (examinee: Examinee) => {
      context.root.$router.push(`/teacher_site/saiten_input_ichimai/${state.sheet_id}/${examinee.id}`).catch(err => {});
    }

    /************************************************************
     * 配点プルダウン変更
     ************************************************************/

    const allotChanged = async (sheetField: SheetField) => {
      state.sheetField = sheetField;
      confirmChangeAllotRef.value.show();
    }

    /************************************************************
     * 配点変更API実行
     ************************************************************/

    const updateAllot = async () => {
      
      confirmChangeAllotRef.value.hide();

      const param: object = {
        sheet_field_idx: state.sheetFields.indexOf(state.sheetField),
        allot: state.sheetField.allot
      };

      await http.post(`/api/teacher/saiten_list/update_allot/${state.sheet.sheet_group_key}`, param).then(response => {
        alert("配点の変更が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      let url = `/api/teacher/saiten_list?sheet_id=${state.sheet_id}`;
      if(context.root.$store.getters.isCompareFirstOrSecond){
        url += `&compare_no=${context.root.$store.state.compare_no}`;
      }
      await http.get(url).then(response => {

        state.sheet = new Sheet(response.data.sheet, response.data.approved_user_name);
        state.delayedJobCount = response.data.create_pdf_job_count
        state.allSaitenStickyNotes = response.data.saiten_sticky_notes.map((x: any) => new SaitenStickyNote(x));

        const fieldActivities: FieldActivity[] = response.data.field_activities.map((x: any) => new FieldActivity(x, state.allSaitenStickyNotes));
        const sheetActivities: SheetActivity[] = new Array<SheetActivity>();
        response.data.sheet_activities.forEach((x: any) => {
          sheetActivities.push(new SheetActivity(x));
        });

        response.data.examinees.forEach((x: any) => {
          state.examinees.push(new Examinee(x, sheetActivities, fieldActivities, state.sheet.sheet_type));
        });

        response.data.sheet_fields.forEach((x: any) => {
          state.sheetFields.push(new SheetField(x, fieldActivities, state.sheet, context.root.$store.getters.isCompare));
        });

        const attendStudentExaminees = state.examinees.filter(x => !x.absent_flg);
        let totalScore = Common.sumArray(attendStudentExaminees.map(x => x.score));
        const totalAllot = state.sheet.allot * attendStudentExaminees.length;
        state.totalScoreAverage = Number((totalScore / attendStudentExaminees.length).toFixed(1));
        state.totalScoreRate = Math.round(totalScore / totalAllot * 100);
        state.totalFieldCount = state.sheetFields.length * attendStudentExaminees.length;
        state.totalFirstSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.firstSaitenCompletedCount));
        state.totalSecondSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.secondSaitenCompletedCount));
        state.totalThirdSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.thirdSaitenCompletedCount));

        if(state.sheet.verify_count == 2){
          state.isSaitenCompleted = state.totalSecondSaitenCompletedCount == state.totalFieldCount;
        }else if(state.sheet.verify_count == 3){
          state.isSaitenCompleted = state.totalThirdSaitenCompletedCount == state.totalFieldCount;
        }else{
          state.isSaitenCompleted = state.totalFirstSaitenCompletedCount == state.totalFieldCount;
        }

        state.isPdfJobProcessing = response.data.is_pdf_processing;
        state.isDispStudentInfo = !state.sheet.is_mask_student_info || context.root.$store.getters.isAdminOrTeacher1 || !context.root.$store.getters.isEntranceOrPractice;
        state.isExistsStudentNoCharacter = state.examinees.filter(x => x.student_no_character != null && x.student_no_character != "").length > 0;
        state.isExistsStudentName = state.examinees.filter(x => x.student_name != null && x.student_name != "").length > 0;
        state.colspan += state.isDispStudentInfo && state.isExistsStudentNoCharacter ? 1 : 0;
        state.colspan += state.isDispStudentInfo && state.isExistsStudentName ? 1 : 0;
        state.colspan += !context.root.$store.getters.isEntranceOrPractice ? 1 : 0;
        state.colspan += !context.root.$store.getters.isEntranceOrPractice ? 1 : 0;
        state.colspan -= context.root.$store.getters.isCompareFirstOrSecond ? 1 : 0;

        const studetnCharacterMaxLength = state.examinees.map(x => x.student_no_character == null ? 0 : x.student_no_character.length).reduce((a,b)=>Math.max(a,b));
        state.studentNoCharacterWidth = studetnCharacterMaxLength > 3 ? studetnCharacterMaxLength * 20 : 65;
        const studentNameWidth = state.examinees.map(x => !x.student_name ? 0 : Common.calculateTextWidth(x.student_name)).reduce((a,b)=>Math.max(a,b)) + 10;
        state.studentNameWidth = studentNameWidth > 164 ? 164 : studentNameWidth;
        
        let rightTableTdWidth = 0;

        state.sheetFields.forEach(sheetField => {
          const fieldName = `${sheetField.part1} ${sheetField.part2} ${sheetField.part3}`.replace("null", "");
          const fieldWidth = Common.calculateTextWidth(fieldName);
          if(fieldWidth > rightTableTdWidth){
            rightTableTdWidth = fieldWidth;
          }

          if(context.root.$store.getters.isEntranceOrPractice){
            const teacherNames = [];
            if(sheetField.first_user_name){
              teacherNames.push(sheetField.first_user_name);
            }
            if(state.sheet.verify_count >= 2 && sheetField.second_user_name){
              teacherNames.push(sheetField.second_user_name)
            }
            if(state.sheet.verify_count >= 2 && sheetField.third_user_name){
              teacherNames.push(sheetField.third_user_name)
            }
            teacherNames.forEach(teacherName => {
              const teacherWidth = Common.calculateTextWidth(teacherName);
              if(teacherWidth > rightTableTdWidth){
                rightTableTdWidth = teacherWidth;
              }
            });
          }

          sheetField.feldActivities.forEach(fieldActivity => {
            let correctWidth = 22 + fieldActivity.saitenStickyNotes.length * 22;
            if(correctWidth > rightTableTdWidth){
                rightTableTdWidth = correctWidth;
              }
          });
        });

        rightTableTdWidth = rightTableTdWidth > 80 ? rightTableTdWidth : 80;

        // 文字数から計算した列幅に左右のpadding(4px*2) + border(1px*2)を追加
        rightTableTdWidth += 10;

        state.rightTableTdWidth = `${rightTableTdWidth}px`;

        for(let i = 1; i <= 100; i++){
          state.scoreOptions.push(new ScoreOption(i, `${i}点`));
        }

        state.scanImageExamineeIds = state.examinees.filter(x => !x.absent_flg).map(x => x.id);
        state.resultImageExamineeIds = state.examinees.filter(x => x.result_image_created).map(x => x.id);

        if(context.root.$store.state.next_field_type == null){
          context.root.$store.commit("setNextFieldType", context.root.$store.getters.isEntranceOrPractice ? Common.NextFieldTypeEnum.Room : Common.NextFieldTypeEnum.Field);
        }

        // 採点画面⇒一覧遷移の場合、前回採点設問列のスクロール位置に移動
        context.root.$nextTick(async () => {
          if(context.root.$store.state.sheet_field_idx != null && context.root.$store.state.saitenListDisplayLeft != null){
            const tdField = document.getElementById(`field-col-${context.root.$store.state.sheet_field_idx}`);
            const fieldArea = document.getElementById(`top-right-table-area`);

            if(tdField && fieldArea){
              let scrollLeft = tdField.offsetLeft - context.root.$store.state.saitenListDisplayLeft;

              const tdLeft = tdField.offsetLeft;
              const tdRight = tdField.offsetLeft + tdField.offsetWidth;
              const fieldAreaLeft = scrollLeft;
              const fieldAreaRight = scrollLeft + fieldArea.offsetWidth;

              if(tdLeft < fieldAreaLeft){
                scrollLeft = tdLeft;
              }

              if(tdRight > fieldAreaRight){
                scrollLeft += (tdRight - fieldAreaRight + 30);
              }

              fieldArea.scrollLeft = scrollLeft;
              document.getElementById(`bottom-right-table-area`).scrollLeft = scrollLeft;
            }

            context.root.$store.commit("setSheetFieldIdx", null);
            context.root.$store.commit("setSaitenListDisplayLeft", null);
          }
        });

        if(context.root.$store.state.isFilterMisaiten == null){
          // 試験一覧から遷移 未採点のみ表示チェックボックスの初期値設定
          if(state.isSaitenCompleted || !context.root.$store.getters.isCompareFinal){
            context.root.$store.commit("setIsFilterMisaiten", false);
          }else{
            context.root.$store.commit("setIsFilterMisaiten", true);
          }
        }else{
          // 採点画面から遷移 基本は遷移前のチェック状態を使用するが
          // チェックONで採点画面へ遷移⇒全問採点完了して採点一覧に戻ってきた場合はチェックを外す
          if(state.isSaitenCompleted){
            context.root.$store.commit("setIsFilterMisaiten", false);
          }
        }

        state.isFilterMisaiten = context.root.$store.state.isFilterMisaiten;

        setDispSheetFieldIds();
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      document.getElementById("bottom-right-table-area").onscroll = scrollChanged;
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
    });



    const showScanImage = (examinee: Examinee) => {
      state.previewScanImageExamineeId = examinee.id;
      state.isScanImageVisible = true;
    }

    const showResultImage = (examinee: Examinee) => {
      state.previewResultImageExamineeId = examinee.id;
      state.isResultImageVisible = true;
    }

    const setDispSheetFieldIds = () => {
      if(state.isFilterMisaiten){
        state.dispSheetFieldIds = state.sheetFields.filter(x => !x.isSaitenCompleted).map(x => x.id);
      }else{
        state.dispSheetFieldIds = state.sheetFields.map(x => x.id);
      }
    }

    watch(() => state.isFilterMisaiten, (newVal, oldVal) => {
      setDispSheetFieldIds();
      context.root.$store.commit("setIsFilterMisaiten", newVal);
    });

    /****************************************
     * 付箋表示切替
     ****************************************/

     const changeStickyPopover = (saitenStickyNote: SaitenStickyNote) => {
      if(saitenStickyNote){
        state.allSaitenStickyNotes.forEach(x => x.is_show_popover = x.id == saitenStickyNote.id);
      }else{
        state.allSaitenStickyNotes.forEach(x => x.is_show_popover = false);
      }
    }

    return {
      ...toRefs(state),
      AnswerImageTypeEnum,
      CompareNoEnum,
      modalRef,
      pdfDownlaodModalRef,
      carouselRef,
      sidebarReviewlImageRef,
      previewScanImageSidebarRef,
      previewResultImageSidebarRef,
      customConfirmModalRef,
      confirmChangeAllotRef,
      convertExecDateText,
      createPdfJob,
      downloadExcel,
      sortStudentNo,
      sortTotalScore,
      sortFieldScore,
      base64Images,
      modalTitle,
      showModalImage,
      carouselPrev,
      carouselNext,
      changePrevModalExaminee,
      changeNextModalExaminee,
      allSelectChanged,
      downloadPdf,
      saitenStart,
      saitenStartIchimai,
      isExcelPdfButtonEnable,
      isPdfButtonVisible,
      approvalButtonClick,
      allotChanged,
      updateAllot,
      showReviewImage,
      hiddenReviewImage,
      initializeReviewExaminee,
      changeReviewExaminee,
      updateReview,
      showScanImage,
      showResultImage,
      updatePublish,
      updateApproval,
      changeStickyPopover,
    };
  }
})
